import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AuthView from './features/auth/Auth';
import StatsPage from './features/stat/StatsPage';
import { useAppSelector } from './redux/hooks';
import Layout from './components/Layout/Layout';
import { NotFound } from './components/NotFound';
import { ErrorBoundary } from './components/ErrorBoundary';
import { buildDefaultStatsPath } from './hooks/useFilters';

function AppRoutes() {
  const token = useAppSelector((state) => state.auth.token);
  // Redirects carry the resolved default filters so /stats is shareable immediately.
  const statsPath = buildDefaultStatsPath();

  return (
    <Routes>
      <Route path="/" element={<Navigate to={token ? statsPath : '/auth'} replace />} />
      <Route path="/auth" element={token ? <Navigate to={statsPath} replace /> : <AuthView />} />
      <Route
        path="/stats"
        element={
          token ? (
            <Layout>
              <StatsPage />
            </Layout>
          ) : (
            <Navigate to="/auth" replace />
          )
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ToastContainer
        theme="dark"
        position="top-right"
        toastStyle={{
          backgroundColor: 'var(--background-elevated)',
          color: 'var(--text-primary)',
          borderRadius: 'var(--radius-sm)',
          boxShadow: 'var(--shadow-medium)',
          border: '1px solid var(--border-color)',
        }}
      />
      <Router>
        <AppRoutes />
      </Router>
    </ErrorBoundary>
  );
}

export default App;
